import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="problem-reports--set-priority"
export default class extends Controller {
  static outlets = ['datagrid']
  connect() {
    this.dialogElement = document.querySelector('dialog#setPriority')
    this.form = this.dialogElement.querySelector('form')

    this.element.addEventListener('click', (e) => {
      e.preventDefault();
      if(this.datagridOutlet.selectedRows.length > 0) {
        this.form.querySelectorAll('input[type="hidden"][name="ids[]"]').forEach((field) => field.remove())
        this.datagridOutlet.selectedRowsAsHiddenFieldIds().forEach((field) => this.form.appendChild(field))
        this.dialogElement.showModal()
      } else {
        alert('Please select at least one row')
      }
    })
  }
}
